// Time conversion constants
export const MILISECONDS_TO_SECONDS = 1/1000; // Convert Miliseconds to Seconds

export const SECONDS_TO_MILLISECONDS = 1000; // Convert Seconds to Milliseconds

export const SECONDS_TO_MINUTES = 1/60; // Convert Seconds to Minutes

export const TWELVE_HOUR_CLOCK_HOURS = 12; // A.M./P.M. split. Used in Anglo countries and colonies including U.S., Canada, Mexico, Australia, New Zealand.

// The Meridiem split of a twelve hour clock as lowercase, non-period separated 'am' or 'pm'.
export const MERIDIEM_SPLIT = {
  AM: 'am',
  PM: 'pm'
}

// Staleness thresholds for color coding (in seconds)
export const STALENESS_THRESHOLDS = {
  WARNING_SECONDS: 60,  // orange threshold
  STALE_SECONDS: 360    // red threshold
};
